import React, { useState } from 'react'
import { auth, googleProvider } from '../firebase/firebase'
import { signInWithEmailAndPassword, signInWithPopup, setPersistence, browserLocalPersistence } from 'firebase/auth'

export default function Login({ onSuccess, onBack }) {
  const [email, setEmail] = useState('')
  const [pass, setPass] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const loginEmail = async (e) => {
    e.preventDefault()
    setLoading(true); setError('')
    try {
      await setPersistence(auth, browserLocalPersistence)
      await signInWithEmailAndPassword(auth, email, pass)
      onSuccess?.()
    } catch (err) {
      setError(err.message || 'Erreur de connexion')
    } finally {
      setLoading(false)
    }
  }

  const loginGoogle = async () => {
    setLoading(true); setError('')
    try {
      await setPersistence(auth, browserLocalPersistence)
      await signInWithPopup(auth, googleProvider)
      onSuccess?.()
    } catch (err) {
      setError(err.message || 'Erreur Google')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <div className="auth-header">
          <div className="logo-inline">
            <i className="fas fa-file-contract"></i><span>Form2Doc</span>
          </div>
          <h1>Connexion</h1>
          <p className="auth-sub">Accédez à votre espace (Dashboard, Documents, Modèles, Clients)</p>
        </div>

        {error && <div className="auth-error">{error}</div>}

        <form className="auth-form" onSubmit={loginEmail}>
          <div className="form-group">
            <label>Email</label>
            <input type="email" required value={email} onChange={e=>setEmail(e.target.value)} placeholder="email@exemple.com" />
          </div>
          <div className="form-group">
            <label>Mot de passe</label>
            <input type="password" required value={pass} onChange={e=>setPass(e.target.value)} placeholder="--------" />
          </div>
          <button className="btn btn-primary auth-submit" disabled={loading}>
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>

        <div className="auth-divider"><span>ou</span></div>

        <button className="btn btn-outline auth-google" onClick={loginGoogle} disabled={loading}>
          <i className="fab fa-google"></i> Continuer avec Google
        </button>

        <button className="btn auth-back" onClick={onBack}>
          <i className="fas fa-arrow-left"></i> Retour à l'accueil
        </button>
      </div>
    </div>
  )
}
